import MultiColumnSection from './multi-column-section';

export default MultiColumnSection;
